/**
 * Created by chris on 12/04/2016.
 */
window.onload = function() {
	document.getElementById("header").classList.add("loaded")

	lax.setup()

	const update = () => {
	  lax.update(window.scrollY)
	  window.requestAnimationFrame(update)
	}

	window.requestAnimationFrame(update)

	let w = window.innerWidth
	window.addEventListener("resize", function() {
	  if(w !== window.innerWidth) {
		lax.updateElements()
	  }
	});
  }

jQuery(document).ready(function($){

	$('#mobile-menu').slicknav({
		allowParentLinks: true,
		parentTag: 'a'
	});

	$(".nav-top").hide();

	$('.counter').countUp();

	var overlay = $('.title-holder > h3');

	overlay.each(function(e, item){
		if((item.innerHTML.length > 40) && (item.innerHTML.length < 60)) {
			$(this).parents('div.overlay').addClass('adjust-hover-smaller');
		}
		if(item.innerHTML.length > 60) {
			$(this).parents('div.overlay').addClass('adjust-hover');
		}
		if(item.innerHTML.length < 40) {
			$(this).parents('div.overlay').removeClass('adjust-hover-smaller');
		}
	})

	// videoSize('.wp-block-embed__wrapper > iframe');

	const height = $('#header').height();
	$('.page-content').css('margin-top', height);
	$('.x-close').click(function(){
		$('.search-overlay').fadeOut();
		$('.search-icon').removeClass('fill-color');
	})
	$('.search-icon').click(function(){
		$('.search-icon').toggleClass('fill-color');
		$('.search-overlay').fadeToggle();
		$('input:text:first').focus();
	})
	$(document).on('scroll', function(){
		let headerPosition = $(document).scrollTop();
		if(headerPosition > 100) {
			$('#header').addClass('shrink');
			$('.mdl-menu').addClass('shrink');
		} else {
			$('#header').removeClass('shrink');
			$('.mdl-menu').removeClass('shrink');
		}
	})


	$('.slicknav_btn').click(function(e){
		// e.preventDefault();
		$(this).toggleClass('transform-nav');
	})
	
	$(window).scroll(function(e) {
		var pos = $(window).scrollTop();
		var end = Math.floor($("#end").offset().top);

		if(pos < 3){
			$(".nav-top").fadeOut();
		}else{
			$(".nav-top").fadeIn();
		}
		
		if($(window).scrollTop() + $(window).height() > $(document).height() - 100){
			$('.nav-bottom').fadeOut();
		}else{
			$('.nav-bottom').fadeIn();
		}

		$(".hero-begin").css("background-position","50% " + ($(this).scrollTop() / 2) + "px");
	});

	if($('body').hasClass('home')) {
		$('.supporting-slider').slick({
			centerMode:true,
			centerPadding: 0,
			arrows: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			cssEase: 'linear',
			variableHeight: true,
			infinite: true,
			fade: true,
			responsive: [
			{
				breakpoint: 768,
				settings: {
				arrows: false,
				centerMode: true,
				centerPadding: '40px',
				slidesToShow: 1
				}
			},
			{
				breakpoint: 480,
				settings: {
				arrows: false,
				centerMode: true,
				centerPadding: '40px',
				slidesToShow: 1
				}
			}
			]
		});
		$('.supporting-nav').slick({
			centerMode:true,
			centerPadding: 30,
			slidesToShow: 5,
			slidesToScroll: 1,
			asNavFor: '.supporting-slider',
			dots: false,
			arrows: false,
			focusOnSelect: true,
			autoplay: true,
			autoplaySpeed: 5000,
			infinite: true,
			responsive: [
				{
					breakpoint: 768,
					settings: {
					arrows: false,
					centerMode: false,
					centerPadding: '40px',
					slidesToShow: 1
					}
				},
				{
					breakpoint: 480,
					settings: {
					arrows: false,
					centerMode: false,
					centerPadding: '40px',
					slidesToShow: 1
					}
				}
			]
		});

		// $('.selected-post').click(function(e){
		// 	let syncImage = e.target.src;
		// 	// $('.sync-image').attr('src', syncImage);
		// 	$(".tab-sync-image").css("background-image", "url(" + syncImage + ")");
		// });
	
		$('.trigger-sync').click(function(e){
			let fdsyncImage = e.target.src;
			$(".fundraiser-sync-image").css("background-image", "url(" + fdsyncImage + ")");
		});

		// setTimeout(() => {
		// 	$('.selected-post')[0].click();
		// }, 1000);

		setTimeout(() => {
			$('.selected-fundraiser-image')[0].click();
		}, 1200);


		$('#fund-tab-1').addClass('active');
		$('#fundraiser-1').addClass('active');
	

		// API tabs
		// Reference the tab links.
		const fundraiserTabLinks = $('.fundraiser-tab-selection a');
	
		// Handle link clicks.
		fundraiserTabLinks.click(function(event) {
			var $this = $(this);
			
			// Prevent default click behaviour.
			event.preventDefault();
			
			// Remove the active class from the active link and section.
			$('.fundraiser-tab-content.active, .fundraiser-tab-selection a.active').removeClass('active');
			
			// Add the active class to the current link and corresponding section.
			$this.addClass('active');
			$($this.attr('href')).addClass('active');
		});
	}

	$('.news-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: true,
		arrows: false,
		autoplay: true
	});

	$(".youtube-btn").modalVideo({channel:'youtube'});
	$(".vimeo-btn").modalVideo({channel:'vimeo'});

	$( "a#expandable" ).each(function(index) {
		$(this).on("click", function(e){
			$(this).parent().parent().next().slideToggle();
			$('html, body').animate({
				scrollTop: $($(this).parent().parent()).offset().top + $(this).parent().height() - 440
			}, 1000);
		});
	});

	$('.gallery').each(function(){
		$(this).magnificPopup({
			delegate: 'a', // child items selector, by clicking on it popup will open
			type: 'image',
			mainClass: 'mfp-img-mobile mfp-with-zoom',
			gallery: {
				enabled: true,
				navigateByImgClick: true,
				arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>', // markup of an arrow button
				preload: [0,1] // Will preload 0 - before current, and 1 after the current image
			},
			zoom: {
				enabled: true, // By default it's false, so don't forget to enable it
			
				duration: 300, // duration of the effect, in milliseconds
				easing: 'ease-in-out', // CSS transition easing function

				opener: function(openerElement) {
					return openerElement.is('a') ? openerElement : openerElement.find('a');
				}
			}
		})
	})
})


jQuery(window).load(function($){
	makesquare('.square');
})

jQuery(window).resize(function($){
	// videoSize('.wp-block-embed__wrapper > iframe');
	makesquare('.square');
})

var list = document.querySelectorAll("#members-content-section");

list.forEach((item, sel) => {
	if(item.hasChildNodes() == false) {
		item.remove();
	}
});


function sizetorow(divheight, target, adjustment){
	var $ = jQuery;
	if($(window).width() > 800){
		var maxHeight = 0;

		$(target).css('min-height',maxHeight);
		var maxHeight = $(divheight).height() - adjustment;
		console.log(maxHeight);
		//$(target).each(function(){
		//
		//})
		setTimeout(function(){
			$(target).css('min-height',maxHeight);
		},600)
	}
}

function makesquare(target){
	var $ = jQuery;
	var width = $(target).width();
	$(target).height(width);
}

function videoSize(target){
	var $ = jQuery;
	var width = $(target).width();
	var height = (width / 16) * 9;
	$(target).height(height);
 }
	